import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from './Icons';
import { mockData } from '../data/mockData';
import useAnalytics from '../hooks/useAnalytics';

const Shelf = () => {
    const navigate = useNavigate();
    const { trackPageView } = useAnalytics();
    const { books, papers } = mockData.shelf;

    useEffect(() => {
        window.scrollTo(0, 0);
        trackPageView('shelf');
    }, [trackPageView]);

    const handleBack = () => {
        navigate('/');
        setTimeout(() => {
            const el = document.getElementById('shelf');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    return (
        <div className="min-h-screen bg-cream-100">
            {/* Header bar */}
            <div className="sticky top-0 z-10 bg-cream-100/90 backdrop-blur-sm border-b border-border-light">
                <div className="max-w-3xl mx-auto px-6 h-14 flex items-center">
                    <button
                        onClick={handleBack}
                        className="flex items-center gap-2 text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors"
                    >
                        <ArrowLeftIcon className="w-4 h-4" />
                        Back
                    </button>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-6 py-12">
                {/* Page heading */}
                <h1 className="font-serif text-4xl text-charcoal-900 mb-12">
                    My <em className="italic-emphasis">shelf</em>
                </h1>

                {/* Bookshelf */}
                <section className="mb-14">
                    <h2 className="font-serif text-2xl text-charcoal-900 mb-6">
                        Bookshelf <span className="text-charcoal-400 font-sans text-lg font-normal">({books.length})</span>
                    </h2>
                    <ul className="space-y-3 list-disc list-inside">
                        {books.map(book => (
                            <li key={book.id} className="text-charcoal-700 text-base leading-relaxed">
                                {book.url ? (
                                    <a
                                        href={book.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-coral-600 hover:underline"
                                    >
                                        {book.title}
                                    </a>
                                ) : (
                                    <span className="text-charcoal-900">{book.title}</span>
                                )}
                                <span className="text-charcoal-500"> by {book.author}</span>
                            </li>
                        ))}
                    </ul>
                </section>

                {/* Papershelf */}
                <section>
                    <h2 className="font-serif text-2xl text-charcoal-900 mb-6">
                        Papershelf <span className="text-charcoal-400 font-sans text-lg font-normal">({papers.length})</span>
                    </h2>
                    <ul className="space-y-3 list-disc list-inside">
                        {papers.map(paper => (
                            <li key={paper.id} className="text-charcoal-700 text-base leading-relaxed">
                                {paper.url ? (
                                    <a
                                        href={paper.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-coral-600 hover:underline"
                                    >
                                        {paper.title}
                                    </a>
                                ) : (
                                    <span className="text-charcoal-900">{paper.title}</span>
                                )}
                                <span className="text-charcoal-500"> by {paper.authors}</span>
                                {paper.venue && (
                                    <span className="text-charcoal-400 text-sm"> · {paper.venue}</span>
                                )}
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default Shelf;
